<template>
  <button 
    id="backToTop" 
    class="fixed bottom-8 right-8 w-12 h-12 rounded-full bg-blue-600 hover:bg-blue-700 text-white flex items-center justify-center shadow-lg transition-all duration-300"
    v-if="showBackToTop"
    @click="backToTop"
  >
    <i class="fas fa-arrow-up"></i>
  </button>
</template>

<script>
import gsap from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

// 注册GSAP ScrollToPlugin插件
gsap.registerPlugin(ScrollToPlugin)

export default {
  name: 'BackToTop',
  data() {
    return {
      showBackToTop: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.showBackToTop = window.pageYOffset > 300
    },
    backToTop() {
      gsap.to(window, {
        duration: 0.8,
        scrollTo: 0,
        ease: 'power2.inOut'
      })
    }
  }
}
</script>

